import { dateUtils } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'
import { Stack, Typography } from '@festina-life/ui/structure'
// oxlint-disable-next-line no-restricted-imports -- kept to not break too many things in the config portal
import { Link } from 'react-router'

import { OperationValidationErrors } from '../../components/operationErrors/OperationValidationErrors'
import { configurationItem } from '../../system/paths'
import { useNavigationParams } from '../../system/useNavigationParams'
import type { IndexedReconciliationSpecOperationWithMetaData } from '../../uiModels/reconciliationSpecOperations/types'
import { useOperationsContext } from '../../workspace/operationsContext'

type Props = {
  reconciliationSpecOperation: IndexedReconciliationSpecOperationWithMetaData
}

/**
 * Metadata of the reconciliation-spec version in scope. Sheets, tables and groups are
 * only editable through Excel, so the specification content itself is never rendered.
 */
export const ReconciliationSpecViewerContent = ({
  reconciliationSpecOperation,
}: Props) => {
  const translate = useTranslate()
  const { server, branch } = useNavigationParams()
  const { workspaceKey } = useOperationsContext()
  const reconciliationSpec =
    reconciliationSpecOperation.internalOperation.reconciliationSpec

  return (
    <div className="size-full overflow-y-auto">
      <Stack className="flex-col max-w-xl" gap="spacious" padding="spacious">
        <OperationValidationErrors
          operationKey={
            reconciliationSpecOperation.internalOperation.operationKey
          }
        />
        <Stack className="flex-col">
          <Typography size="lg">
            {translate('reconciliationSpecViewer.from.label')}
          </Typography>
          <Typography>
            {dateUtils.dateAsStr(reconciliationSpec?.from)}
          </Typography>
        </Stack>
        <Stack className="flex-col">
          <Typography size="lg">
            {translate('reconciliationSpecViewer.description.label')}
          </Typography>
          <Typography>
            {reconciliationSpec?.specDescription?.trim() ||
              translate('reconciliationSpecViewer.description.emptyState')}
          </Typography>
        </Stack>
        <Stack className="flex-col">
          <Typography size="lg">
            {translate('reconciliationSpecViewer.mappingId.label')}
          </Typography>
          {reconciliationSpec?.mappingId ? (
            <Link
              to={configurationItem({
                workspaceName: workspaceKey?.name,
                layer: reconciliationSpecOperation.layer,
                block: reconciliationSpecOperation.block,
                server,
                itemId: reconciliationSpec.mappingId,
                branch,
                type: 'glMap',
              })}
              className="w-fit text-amaze-inkBright underline hover:opacity-90"
            >
              {reconciliationSpec.mappingId}
            </Link>
          ) : (
            <Typography>
              {translate('reconciliationSpecViewer.mappingId.emptyState')}
            </Typography>
          )}
        </Stack>
      </Stack>
    </div>
  )
}
